module.exports = __webpack_public_path__ + "img/lit_asic_miner.7c1402c1.png";